/* eslint-disable consistent-return */
import { Icon, Loader, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {
    getNormalizedLOBName,
    isCapabilityEnabled,
} from '@xengage/gw-portals-config-js';
import { BreakpointTrackerContext } from '@jutro/layout';
import { generateURL } from '@xengage/gw-portals-url-js';
import { LocalDateUtil, DatatableUtil } from '@xengage/gw-portals-util-js';
import appConfig from 'app-config';
import { ServiceManager } from '@jutro/legacy/services';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import { DocumentService } from 'gw-capability-policydocument';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { AMPSubmissionDraftService } from 'gw-capability-quoteandbind';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { DropdownSelectField } from '@jutro/components/internal';
import messages from './LandingPage.messages';
import metadata from './LandingPage.metadata.json5';
import styles from './LandingPage.module.scss';

const getCellType = rowData => {
    const activePeriod = _.first(rowData.periods);
    const lineOfBusiness =
        activePeriod.lines.length > 1
            ? activePeriod.lines_TWIA.map(line => line)
            : _.first(activePeriod.lines_TWIA);

    return lineOfBusiness.policyType_TWIA
};

const shouldRenewalNotificationShow = (accountPolicyData) =>accountPolicyData.flatMap(aod => aod.periods).some(period => period.jobType_TWIA === 'Renewal').length > 0 
    


const getCellStatus = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const { status } = activePeriod;

    return (
        <span>
            {status}
        </span>
    );
};

const getCellAccount = rowData => {
    const { accountNumber } = rowData;

    return (
        <div className={styles.offerLink}>
            <span>
                {accountNumber}
            </span>
        </div>

    );
};

// US25435 should links show up on the offers page?
const showLink = period => period.status === 'Renewing' || period.status === 'Offer Submitted';

const getCellPolicy = (rowData, isPolicy) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find(
        policy => policy.idCardPublicID
    );

    return (
        showLink(activePeriod) || isPolicy ?
            <div className={styles.offerLink}>
                <Link
                    className={styles.link}
                    to={{
                        pathname: `/account-policy-details/${activePeriod.policyId}`,
                        productCode: activePeriod.lines[0],
                        idCard: periodWithIDCard
                            ? {
                                idCardSessionID: _.get(
                                    periodWithIDCard,
                                    'idCardSessionID'
                                ),
                                idCardPublicID: _.get(
                                    periodWithIDCard,
                                    'idCardPublicID'
                                ),
                            }
                            : null,
                    }}
                >
                    {activePeriod.policyId}
                </Link>
            </div> :
            (<div className={styles.OfferLink}><span>{activePeriod.policyId}</span></div>)
    );
};

// 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
// const getCellEffective = (rowData, rowIndex) => {
//     const activePeriod = _.first(rowData.periods);
//    
//     const effectiveDate = LocalDateUtil.toMidnightDate(activePeriod.effective);
//     const expirationDate = LocalDateUtil.toMidnightDate(
//         activePeriod.expiration
//     );
//     const periodValue = {
//         startDate: {
//             year: effectiveDate.getFullYear(),
//             month: effectiveDate.getMonth(),
//             day: effectiveDate.getDate(),
//         },
//         endDate: {
//             year: expirationDate.getFullYear(),
//             month: expirationDate.getMonth(),
//             day: expirationDate.getDate(),
//         },
//     };
//
//     return (
//         <DateRangeField
//             id={`effectiveDate_${rowIndex}`}
//             value={periodValue}
//             hideLabel
//             readOnly
//         />
//     );
// };

// 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
const getCellEffective = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const effectiveDateStr = new Date(activePeriod.effective).toLocaleDateString();
    const expirationDateStr = new Date(activePeriod.expiration).toLocaleDateString();

    return effectiveDateStr.concat(' - ').concat(expirationDateStr);
};

const getCellPremium = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);

    return (
        <CurrencyField
            id={`premium_${rowIndex}`}
            value={activePeriod.totalCost_TWIA}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const { capabilitiesConfig } = appConfig;

function LandingPage(props) {
    const translator = useTranslator();
    const [accountBillingData, setAccountBillingData] = useState([]);
    const [accountPolicyData, setAccountPolicyData] = useState([]);
    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
    const [accountOfferData, setAccountOfferData] = useState([]);
    const authData = useAuthentication()
    const authHeader = _.get(authData, 'authHeader');
    const authUserData = _.get(authData, 'authUserData');
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
    const producerData = _.get(authData, 'producerData');
    const [accountData, setAccountData] = useState([]);
    const [isLoading, setLoadingState] = useState(true);
    const { showConfirm } = useModal();
    const [policyFilterValue, setPolicyFilterValue] = useState('CurrentPolicies');
    const policyFilterList = [{ code: 'CurrentPolicies', name: 'Current Policies' }, { code: 'ShowAll', name: 'Show All' }];
    const localeService = ServiceManager.getService('locale-service');
    const defaultCurrencyCode = localeService.getDefaultCurrencyCode();
    const breakpoint = useContext(BreakpointTrackerContext)

    // const isPhone = breakpoint === 'phoneWide' || breakpoint === 'phone';

    useEffect(() => {
        if (authHeader) {
            setLoadingState(true);

            let billingPromise = Promise.resolve([]);

            if (
                isCapabilityEnabled({
                    capabilitiesConfig,
                    capabilityName: 'billing',
                })
            ) {
                billingPromise =
                    AccountBillingDetailsService.getAccountBillingSummary(
                        authHeader
                    );
            }

            Promise.all([
                billingPromise.then(setAccountBillingData),
                PolicyService.getAccountPolicySummaries_TWIA('CurrentPolicies', authHeader).then(
                    setAccountPolicyData
                ),
                // 2024-11-04- Debra Frum - US25431 - CE - Review and Pay Available Offers?
                PolicyService.getAccountPolicyOffers(authHeader).then(
                    setAccountOfferData
                ),
                UsersProfileDetailsService.getAccountsContactSummaries(authHeader).then(
                    setAccountData
                ),
            ]).finally(() => {
                setLoadingState(false);
            });
            // disable re render

        }
    }, [authHeader]);

    const onFilterValueChange = (value) => {
        setLoadingState(true);
        PolicyService.getAccountPolicySummaries_TWIA(value, authHeader).then(
            setAccountPolicyData
        ).finally(() => {
            setLoadingState(false);
        });
        setPolicyFilterValue(value)
    }

    const aggregateBilling = useCallback(invoices => {
        if (invoices.length === 0) {
            return null;
        }

        let total = 0;
        let due = new Date(invoices[0].dueDate);

        _.each(invoices, invoice => {
            total += invoice.amountDue.amount;

            const newDue = new Date(invoice.dueDate);

            if (newDue.getTime() < due.getTime()) {
                due = newDue;
            }
        });

        return {
            amountDue: {
                amount: total,
                currency: invoices[0].amountDue.currency,
            },
            earliestDue: due,
        };
    }, []);

    const getMyBalanceOverDueAndCurrentData = useCallback(
        invoiceStatus => {
            if (accountBillingData.activeInvoices) {
                const invoices = accountBillingData.activeInvoices;

                return aggregateBilling(
                    invoices.filter(
                        invoice => invoice.invoiceStatus === invoiceStatus
                    )
                );
            }

            return null;
        },
        [accountBillingData.activeInvoices, aggregateBilling]
    );

    const getMyBalancePlannedData = useCallback(
        invoiceStatus => {
            if (accountBillingData.futureInvoices_TWIA) {
                const invoices = accountBillingData.futureInvoices_TWIA;

                return aggregateBilling(
                    invoices.filter(
                        invoice => invoice.invoiceStatus === invoiceStatus
                    )
                );
            }

            return null;
        },
        [accountBillingData.futureInvoices_TWIA, aggregateBilling]
    );

    const getBalanceData = useCallback(() => {
        const overdue = getMyBalanceOverDueAndCurrentData('due');
        const current = getMyBalanceOverDueAndCurrentData('billed');
        const planned = getMyBalancePlannedData('planned');

        if (overdue || current || planned) {
            return {
                amount: _.get(current, 'amountDue.amount', 0.0) + _.get(overdue, 'amountDue.amount', 0.0) + _.get(planned, 'amountDue.amount', 0.0),
                currency: _.get(current, 'amountDue.currency'),
            };
        }

        return null;
    }, [getMyBalanceOverDueAndCurrentData, getMyBalancePlannedData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'balanceAmount') {
                return getBalanceData();
            }

            if (path === 'overDueAmount') {
                return _.get(
                    getMyBalanceOverDueAndCurrentData('due'),
                    'amountDue'
                );
            }

            if (path === 'currentAmount') {
                return _.get(
                    getMyBalanceOverDueAndCurrentData('billed'),
                    'amountDue'
                );
            }

            if (path === 'dueDate') {
                return _.get(
                    getMyBalanceOverDueAndCurrentData('due'),
                    'earliestDue'
                );
            }

            return _.get(accountBillingData, path);
        },
        [accountBillingData, getBalanceData, getMyBalanceOverDueAndCurrentData]
    );

    const policyWithIDCard = useMemo(() => {
        let periodWithIDCard;

        accountPolicyData.some(policyData => policyData.periods.some(period => {
            if (period.idCardPublicID) {
                periodWithIDCard = period;

                return true;
            }

            return false;
        }));

        return periodWithIDCard;
    }, [accountPolicyData]);

    const getIDCardQuickLink = useMemo(() => {
        if (!policyWithIDCard) {
            return null;
        }

        return DocumentService.downloadPolicyDocument(
            policyWithIDCard.idCardPublicID,
            policyWithIDCard.idCardSessionID
        );
    }, [policyWithIDCard]);

    const automatedPaymentURL = useMemo(() => {
        const billingID = _.get(
            accountBillingData,
            'manualPayPaymentGroups[0]'
        );

        if (!billingID) {
            return undefined;
        }

        return `billing-summary/${billingID}`;
    }, [accountBillingData]);

    // eslint-disable-next-line no-secrets/no-secrets
    // const firstAccountSummaryDefined = useMemo(() => accountData.length <= 1 && !_.isEmpty(accountData), [accountData]);

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const claimCapabilityCheck = useMemo(() => isCapabilityEnabled({
        capabilitiesConfig,
        capabilityName: 'fnol',
    }), []);

    const enrollmentCapabilityCheck = useMemo(() => isCapabilityEnabled({
        capabilitiesConfig,
        capabilityName: 'enrollment',
    }), []);

    const onQuoteQuickLinkClick = useCallback(
        lob => () => {
            const accountSummary = accountData[0];
            const submission = {
                baseData: {
                    productCode: lob,
                    accountHolder: accountSummary,
                    accountNumber: accountSummary.accountNumber,
                    policyAddress: accountSummary.accountContact.primaryAddress,
                    periodStartDate: LocalDateUtil.today(),
                },
            };

            AMPSubmissionDraftService.createForAccount(
                submission,
                authHeader
            ).then(savedSubmission => {
                const { url } = appConfig.quoteAndBuy;
                const location = `${url}/quote-${getNormalizedLOBName(lob)}`;
                const params = {
                    quoteID: savedSubmission.quoteID,
                    postalCode:
                        savedSubmission.baseData.policyAddress.postalCode,
                };

                window.location = generateURL(location, params);
            });
        },
        [accountData, authHeader]
    );

    const getCellAgent = useCallback(
        rowData => (
            <div className={styles.agentCell}>
                <Button
                    type="text"
                    className={styles.linkButton}
                    onClick={e =>
                        mailToTrigger(e, rowData.producerContact.email)
                    }
                >
                    {rowData.producerContact.displayName}
                </Button>
                {rowData.producerContact.phoneNumber ? (
                    <span>
                        {translator(messages.policyDetailsTel)}
                        {rowData.producerContact.phoneNumber}
                    </span>
                ) : (
                    ''
                )}
            </div>
        ),
        [mailToTrigger, translator]
    );

    const getCellClaim = useCallback((rowData) => {
        const activePeriod = _.first(rowData.periods);
        const redirectClaimsPath = `/home`;
        const initializationPath = `/policies`;

        const redirectPath = {
            pathname: '/fnol-select-policy',
            state: {
                policyNumber: activePeriod.policyId,
                redirectPath: redirectClaimsPath,
                initializationPath
            },
        };

        return (
            <Link to={redirectPath} title={translator(messages.fileClaim)} className={styles.link}>
                <Icon
                    icon="gw-folder"
                    id="id-gw-folder"
                    size="large"
                />
            </Link>
        );
    }, [translator]);

    const getTableOverrides = useCallback(() => ({
        accountColumn: { renderCell: getCellAccount },
        typeColumn: { renderCell: getCellType },
        statusColumn: { renderCell: getCellStatus },
        policyColumn: { renderCell: getPolicyNumberLink },
        effectiveColumn: { renderCell: getCellEffective },
        premiumColumn: { renderCell: getCellPremium },
        fileAClaimColumn: {
            visible: claimCapabilityCheck,
            renderCell: getCellClaim,
        },
        agentColumn: {
            visible: accountData.length > 1,
            renderCell: getCellAgent,
        },
    }), [accountData?.length, claimCapabilityCheck, getCellAgent, getCellClaim]);

    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
    const getOfferCellPremium = (rowData, rowIndex) => {
        const activePeriod = _.first(rowData.periods);

        return (
            <CurrencyField
                id={`totalCost_TWIA${rowIndex}`}
                value={activePeriod.totalCost_TWIA}
                dataType="object"
                readOnly
                hideLabel
            />
        );
    };

    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
    const getOfferCellAccountNumber = (rowData) => rowData.accountNumber;

    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
    const getOfferCellPolicyType = (rowData) => {
        const activePeriod = _.first(rowData.periods);

        return activePeriod.lines_TWIA[0].policyType_TWIA;
    };

    // 2024-11-04- Debra Frum -  - CE - Review and Pay Available Offers?
    const getCellOffer = rowData => {
        const activePeriod = _.first(rowData.periods);

        return (
            <div className={styles.offerLink}>
                <Link
                    className={styles.link}
                    to={{
                        pathname: `/account-offer-details/${activePeriod.jobIdTWIA}`,
                        productCode: activePeriod.lines[0]
                    }}
                >
                    {activePeriod.jobIdTWIA}
                </Link>
            </div>

        );
    };

    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
    const getOfferCellOfferOrPolicyNumber = (rowData) => {
        const activePeriod = _.first(rowData.periods);

        if (activePeriod.jobType_TWIA === 'Submission') {
            // return activePeriod.jobIdTWIA;
            return getCellOffer(rowData);
        }

        if (activePeriod.jobType_TWIA === 'Renewal') {
            // return activePeriod.policyId;
            return getCellPolicy(rowData, false);
        }

    };

    const getPolicyNumberLink = (rowData) => getCellPolicy(rowData, true)

    const getOfferCellReviewPay = (rowData) => {
        const activePeriod = _.first(rowData.periods);
        let showButton = true;

        let redirectPath = '';

        if (activePeriod.jobType_TWIA === 'Submission') {
            redirectPath = `/account-management/account-offer-details/${activePeriod.jobIdTWIA}`;
        } else if (activePeriod.jobType_TWIA === 'Renewal') {
            redirectPath = `/account-management/account-policy-details/${activePeriod.policyId}`;
            showButton = showLink(activePeriod);
        }

        return (
            showButton ?
                <a href={redirectPath}>
                    <Button>
                        {translator(messages.offerDetailsReviewPayMobile)}
                    </Button>
                </a> :
                <span />
        );
    };

    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
    // const getOfferCellStatus = (rowData, rowIndex) => {
    //     const activePeriod = _.first(rowData.periods);
    //     return activePeriod.status;
    // };


    // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
    const getOffersTableOverrides = useCallback(() => ({
        offerAccountNumberColumn: { renderCell: getOfferCellAccountNumber },
        offerPolicyTypeColumn: { renderCell: getOfferCellPolicyType },
        offerNumberColumn: { renderCell: getOfferCellOfferOrPolicyNumber },
        offerEffectiveColumn: { renderCell: getCellEffective },
        offerPremiumColumn: { renderCell: getOfferCellPremium },
        offerReviewPayColumn: { renderCell: getOfferCellReviewPay },
        // offerStatusColumn: { renderCell: getOfferCellStatus },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [accountOfferData]);


    const onFileAClaimQuickLinkClick = useCallback(
        () => () => {
            const { history } = props;
            const redirectClaimsPath = `/home`;
            const initializationPath = `/claims`;

            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: redirectClaimsPath,
                    initializationPath,
                    claimData: {},
                },
            });
        },
        [props]
    );

    const handleLinkClick = useCallback(
        event => {
            const { history } = props;

            return history.push(event.path);
        },
        [props]
    );

    const showBillingSection = useMemo(() => isCapabilityEnabled({
        capabilitiesConfig,
        capabilityName: 'billing',
    }), []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const searchTableFilter = filterValue => row => {
        const val = filterValue.toLowerCase();
        const activePeriod = _.first(row.periods);

        return (
            row.accountNumber.toLowerCase().includes(val) ||
            activePeriod.status.toLowerCase().includes(val) ||
            activePeriod.lines_TWIA.map(item => item.policyType_TWIA).some(item => item.toLowerCase().includes(val))
        );
    };

    const onWindstormLinkClick = () => {
        window.open('https://www.twia.org/windstorm-certification/', '_blank')
    }

    const getEmail = () => {
        if (producerData && producerData.email) {
            return (
                <a href={`mailto:${producerData.email}`}>{producerData.email}</a>
            )
        }

        return '';
    }

    const getPhone = () => {
        if (producerData && producerData.phoneNumber) {
            return producerData.phoneNumber
        }

        return '';
    }

    const onChangePasswordClick = () => {
        showConfirm({
            title: messages.changePassword,
            message: messages.confirmLogout,
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok,
            cancelButtonText: commonMessages.cancelModel,
        }).then(results => {
            if (results === 'confirm') {
                authData.logout()
            }
        }, _.noop);
    }

    const getPoliciesTableHeader = () => (
        <div className={styles.policiesTitle}>
            <h3>{translator(messages.policies)}</h3>
            <div>
                <DropdownSelectField
                    availableValues={policyFilterList}
                    onValueChange={onFilterValueChange}
                    value={policyFilterValue}
                />
            </div>
        </div>
    )

    const getWelcomContent = () => (
        <span>{translator(messages.welcomeNote)}<Link target="_blank" href="https://www.twia.org/support">{translator(messages.welcomeNoteLink)}</Link></span>
    )


    const override = {
        '@field': {
            phone: {
                labelPosition: 'left'
            },
        },
        myBalanceOverdueAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due')),
        },
        myBalanceCurrentAmount: {
            // visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed')),
            visible: false,
        },
        dueDateContainer: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due')),
        },
        dueDateLabel: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed')),
        },
        payNowButton: {
            // visible: firstAccountSummaryDefined,
            visible: false,
        },
        mediaSidebar: {
            showContact: (accountData.length === 1),
            uwCompany: authUserData?.associationName_TWIA
        },
        policiesTable: {
            data: accountPolicyData,
            onFilter: searchTableFilter
        },
        // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
        offersTable: {
            data: accountOfferData,
            onFilter: searchTableFilter
        },
        printAnIDCardLink: {
            // visible: !_.isNil(policyWithIDCard),
            href: getIDCardQuickLink,
            target: '_blank',
            visible: false
        },
        setupAutomatedPaymentsLink: {
            onClick: {
                callback: 'handleLinkClick',
                callbackProps: {
                    path: automatedPaymentURL,
                },
            },
            visible: false,
        },
        getAPAQuote: {
            onClick: onQuoteQuickLinkClick('PersonalAuto'),
            visible: false
            // visible:
            //     appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined,
        },
        getAHOQuote: {
            onClick: onQuoteQuickLinkClick('Homeowners'),
            visible: false
            // visible:
            //     appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined,
        },
        renewalNotification: {
            visible: shouldRenewalNotificationShow(accountPolicyData),
        },
        fileAClaimLink: {
            onClick: onFileAClaimQuickLinkClick(),
            visible: claimCapabilityCheck,
        },
        tileGroupContainer: {
            visible: showBillingSection,
        },
        makeAPaymentLink: {
            visible: showBillingSection,
        },
        windstormCertificationLink: {
            onClick: onWindstormLinkClick,
        },
        changePasswordLink: {
            onClick: onChangePasswordClick,
        },
        enrollPoliciesContainer: {
            visible: enrollmentCapabilityCheck,
        },
        renewalOfferNotification: {
            message: translator(messages.renewalBannerText),
            visible: accountOfferData
                .flatMap(aod => aod.periods)
                .some(period => period.jobType_TWIA === 'Renewal')
        },
        agentContainer: {
            visible: !!producerData && !!producerData.organisation
        },
        agentName: {
            content: producerData ? producerData.organisation : ''
        },
        agencyDesc: {
            content: producerData ? producerData.groupDescription_TWIA : ''
        },
        agencyPhone: {
            content: getPhone()
        },
        agencyEmail: {
            content: getEmail()
        },
        balanceDate: {
            visible: false
        },
        offersNote: {
            visible: accountOfferData?.length > 0
        },
        policiesTableTitle: {
            content: getPoliciesTableHeader()
        },
        welcomeContainer: {
            visible: !isTFPA
        },
        welcomeNote: {
            content: getWelcomContent()
        },
        personalizedRectangleOffer: {
            visible: false
        },
        halfBannerContainer: {
            visible: false
        },
        ...getTableOverrides(),
        // 2024-11-04 - Debra Frum - US25431 - CE - Review and Pay Available Offers?
        ...getOffersTableOverrides(),
    };

    const onSortCurrency = (prev, next) => {
        const prevData = prev || { amount: 0, currency: defaultCurrencyCode };
        const nextData = next || { amount: 0, currency: defaultCurrencyCode };

        return DatatableUtil.sortCurrency(prevData, nextData)
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleLinkClick,
            sortDate: DatatableUtil.sortDate,
            sortCurrency: onSortCurrency,
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={override}
            {...resolvers}
        />
    );
}

export default withRouter(LandingPage);
